import * as React from "react";
import { RelayEnvironmentProvider } from "react-relay";
import { RelayEnvironment } from "./environment";

export default function RelayProvider({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    return (
        <RelayEnvironmentProvider environment={RelayEnvironment}>
            {children}
        </RelayEnvironmentProvider>
    );
}
